import type { ContextTicketDto } from '../views/HomeView/HomeView';

export const TICKETS_PAGE_SIZE = 20;

export interface FetchTicketsPageOptions {
  from?: number;
  size?: number;
  userGuid?: string;
}

export interface FetchTicketsPageResult {
  tickets: ContextTicketDto[];
  hasMore: boolean;
}

export async function fetchTicketsPage(
  options: FetchTicketsPageOptions = {},
): Promise<FetchTicketsPageResult> {
  const from = options.from ?? 0;
  const size = options.size ?? TICKETS_PAGE_SIZE;
  const params = new URLSearchParams();
  params.set('from', String(from));
  params.set('size', String(size));
  if (options.userGuid) {
    params.set('User_guid', options.userGuid);
  }

  const response = await fetch(
    `${process.env.API_HOST || ''}/api/v1/tickets?${params.toString()}`,
    {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
    },
  );

  if (!response.ok) {
    throw new Error(
      `Failed to fetch tickets: ${response.status} ${response.statusText}`,
    );
  }

  const tickets: ContextTicketDto[] = await response.json();

  return {
    tickets,
    hasMore: tickets.length === size,
  };
}
